import React, { Component } from "react";
import { Link } from "react-router-dom";
import { decode as base64_decode, encode as base64_encode } from "base-64";

import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import HelpModal from "./HelpModal";
import SecuretrackDistributorAdd from "./SecuretrackDistributorAdd";

import {
  Tooltip,
  Button,
  Row,
  Col,
  Typography,
  Image,
  Form,
  Space,
  Input,
  Checkbox,
  message,
  Modal
} from "antd";
import Cookies from "universal-cookie";
import conf from "../config";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import DistributorFleetCountStore from "../store/DistributorFleetCountStore";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { color } from "d3";
const { Title } = Typography;
class DistributorsLogin extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.formRef = React.createRef();
    this.DistributorFleetCountStore = new DistributorFleetCountStore(this);
    this.state = {
      openDistributorForm : false
    }
  }

  componentDidMount() {
    this.getDistributors();
  }

  getDistributors = async (value) => {
    const currentUserType = this.props.getUserData().userType;
    const storedUserType = parseInt(localStorage.getItem("originalUserType"));
    const storedCompanyId = localStorage.getItem("originalCompanyId");

    const isMasterUser = currentUserType === 8 || storedUserType === 8;

    if (isMasterUser) {
      await this.DistributorFleetCountStore.getDistributors({
        companyId:
          currentUserType === 8
            ? this.props.getUserData().userCompanyId
            : storedCompanyId,
      });

      await this.setState({ update: 1 });
    }
  };

  handleDistributorLogin = async (companyId) => {
    try {
      const masterUserId =
        this.props.getUserData().userType === 8
          ? this.props.getUserData().userId
          : localStorage.getItem("originalUserId");

      // 1. Call your store to get login data
      const loginResponse =
        await this.DistributorFleetCountStore.getDistributorLoginData(
          companyId,
          masterUserId
        );
      const { username, password } = loginResponse?.data?.userData || {};

      if (!username || !password) {
        return message.error("Username or password not found.");
      }

      this.setState({ loading: true });

      const resData =
        await this.DistributorFleetCountStore.loginWithCredentials(
          username,
          password
        );

      console.log(resData, "resData");

      if (resData?.success === "S") {
        const data = resData.data;
        console.log(data.token, "data.token");
        const coockieData = {
          userToken: data.token,
          userName: data.name,
          userCompanyId: data.companyId,
          logo: data.logo,
          userId: data.userId,
          isadmin: data.isadmin,
          issuperadmin: data.issuperadmin,
          photo: data.phocoockieDatato,
          mapSetting: data.mapSetting,
          mapSetting2: data.mapSetting2,
          roleId: data.roleId,
          showLaunchingDashboard:
            conf.project === "drive7"
              ? 0
              : conf.project === "securetrack"
              ? 2
              : 1,
          userType: data.userType,
        };

        // Set cookies
        this.cookies.set("data", base64_encode(JSON.stringify(coockieData)), {
          path: "/",
        });
        this.cookies.set("mapShow", 1);
        this.cookies.set("isAdmin", coockieData.isadmin === 1 ? 1 : -1);
        localStorage.setItem(
          "rolePermission",
          JSON.stringify(data.rolePermission)
        );

        message.success("Login Successful", 2);

        // 3. Navigate to correct dashboard
        if (coockieData.showLaunchingDashboard === 0) {
          this.props.navigate("/livetracking");
        } else if (coockieData.showLaunchingDashboard === 2) {
          if (coockieData.userType === 8) {
            this.props.navigate("/DistributorsLogin");
          } else if (coockieData.isadmin === 3) {
            this.props.navigate("/DistributorOptionsMain");
          } else {
            this.props.navigate("/SecureTrackMonitor");
          }
        } else {
          this.props.navigate("/lounchingDashboard");
        }
      } else {
        message.error(resData.errors?.loginerror || "Login failed");
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong.");
    } finally {
      this.setState({ loading: false });
    }
  };
  responseMsg = async (response) => {
      // console.log(resp);
      if (response?.success === "S") {
        message.success(response.message);
        // this.props.navigate("/companylist");
        this.setState({ openDistributorForm: false });
        this.getDistributors();
      
      } else {
        if (response.errors[0].companyname) {
          message.error(this.context.translate(response.errors[0]?.companyname));
        }
        if (response.errors[0]?.username) {
          message.error(this.context.translate(response.errors[0]?.username));
        }
        this.setState({ loading: false });
      }
    };

  render() {
    const formItemStyle = { marginBottom: "2px", marginTop: "2px" };

    const buttonStyle = {
      borderRadius: "20px",
      width: "240px",
      height: "40px",
      fontWeight: "500",
      textTransform: "capitalize",
    };

    return (
      <div className="login-screen">
        <div className="login-overlay">
          <div className="login-form-container">
            <div className="loginlogo-main">
              <Image
                src={require("../assets/images/swd-dashboard-st.png")}
                alt="SecureTrackX"
                preview={false}
                className="mainLogo"
              />
            </div>
            <div className="distributors-login">
              <Title
                level={5}
                className="white-text"
                style={{ marginBottom: "5px", color: "white" }}
              >
                Select or  <Button
                      //key={index}
                     // loading={this.state.loading}
                      type="default"
                      style={{ backgroundColor: 'green', color: 'white', borderColor: 'green' }}
                       onClick={() =>
                         this.setState({openDistributorForm:true})
                       }
                    >
                      Add Admin
                    </Button>
              </Title>
              <Space direction="vertical" size="middle">
                {this.DistributorFleetCountStore?.companydetails.map(
                  (item, index) => (
                    <Button
                      key={index}
                      loading={this.state.loading}
                      type="default"
                      style={buttonStyle}
                      onClick={() =>
                        this.handleDistributorLogin(item.companyId)
                      }
                    >
                      {item.name}
                    </Button>
                  )
                )}
              </Space>
            </div>
          </div>
        </div>
        
      {this.state.openDistributorForm && (
          <Modal
            bodyStyle={{ height: "100%" }}
            className="formShowModal" //  {/* css class */}
            // title="Add New Vehicle"
            maskClosable={false}
            title={this.context.translate("_ADD_DISTRIBUTOR_")}
            centered
            visible={this.state.openDistributorForm}
            footer={null}
            onCancel={() => {
              this.setState({ openDistributorForm: false });
            }}
            width={665}
          >
            <div>
              <SecuretrackDistributorAdd
                vehicleIdForEdit={this.state.vehicleIdForEdit}
                response2={this.responseMsg}
                closeModal={this.closeModal}
                fromVehicleList={true}
              />
              {/* companyId={this.state.companyId} ID={this.state.assignId} response={this.assignresponseMsg} */}
            </div>
          </Modal>
        )}
      </div>

    );
  }
}
DistributorsLogin.contextType = StoreContext;
export default observer(withRouter(DistributorsLogin));
